/** Text shared by several pages. Page-specific text lives in its own file. */
export default {
  language: "Language",
  nav: {
    howItWorks: "How It Works",
    demo: "Demo",
    pricing: "Pricing",
    faq: "FAQ",
    contact: "Contact",
    generate: "Generate",
    generateNow: "Generate Now",
    profile: "Profile",
    signIn: "Sign in",
    signOut: "Sign out",
    toggleMenu: "Toggle menu",
  },
  actions: {
    backToHome: "Back to home",
    backToPricing: "Back to pricing",
    tryAgain: "Try again",
    loading: "Loading…",
    pleaseWait: "Please wait…",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    copy: "Copy",
    copied: "Copied",
    download: "Download",
  },
  legal: {
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Refund Policy",
    deliveryPolicy: "Delivery Policy",
    cookiePolicy: "Cookie Policy",
  },
  cookies: {
    banner: {
      title: "We value your privacy",
      text: "We use strictly necessary cookies to keep you signed in and to run checkout. With your consent we also remember your language and keep your recent generations in this browser. We use no analytics or advertising cookies. You can change your choice at any time under “Cookie settings” in the site footer.",
    },
    acceptAll: "Accept all",
    rejectOptional: "Reject optional",
    customize: "Customize",
    save: "Save my choices",
    settingsTitle: "Cookie settings",
    settingsIntro: "Choose which optional cookies we may use. Strictly necessary cookies are always on because the site cannot work without them. Turning a category off deletes what it has stored.",
    alwaysOn: "Always on",
    footerLink: "Cookie settings",
    categories: {
      necessary: {
        name: "Strictly necessary",
        description: "Keep you signed in, keep your checkout details while you pay at the bank, and remember your cookie choices.",
      },
      preferences: {
        name: "Preferences",
        description: "Remember the language you chose, so the site opens in it next time.",
      },
      functional: {
        name: "Functionality",
        description: "Keep your recent images and videos on the Generate page after you close it.",
      },
    },
  },
  merchant: {
    title: "Merchant of record",
    company: "Company",
    tradingAs: "trading as {{name}}",
    uic: "Company ID",
    uicValue: "UIC {{uic}} · registered and domiciled in Bulgaria (EU)",
    address: "Address",
    website: "Website and contact",
  },
  contentRules:
    "Everything here is AI-generated. Sexual, violent, hateful or illegal content and realistic images of real people without their consent are not allowed — prompts are checked automatically. See our <terms>acceptable use rules</terms>.",
  prices: {
    note: "All prices are in euros (EUR) and include all applicable taxes. No hidden fees, no minimum order.",
  },
  banks: {
    dsk: "DSK Bank",
    postbank: "PostBank",
  },
  errors: {
    generic: "Something went wrong. Please try again.",
    unexpected: "Unexpected error.",
  },
};
